import createAction, {ReducerActionInterface} from "../../../lib/reducer.utils";
import {NewsletterModel} from "../../../models/newsletter.model";

/* Actions */
export const NewsletterActionTypes = {
    "SET_EMAIL": "newsletter/SET_EMAIL"
}

export const INITIAL_STATE: NewsletterModel = {
    id: 0, identifier: "",
    email: ""
}



export const newsletterReducer = (state = INITIAL_STATE, action: ReducerActionInterface) => {
    const { type, payload } = action;

    switch (type) {
        case NewsletterActionTypes.SET_EMAIL:
            return {
                ...state,
                email: payload
            }

        default: return state;
    }
}

/* Selectors */
export const getNewsLetterEmail = (state: any) => state.newsletter.email;

/* Actions */
export const setNewsLetterEmail = (email: string) => createAction({
    type: NewsletterActionTypes.SET_EMAIL,
    payload: email
})